import { useMutation } from 'react-query';

import { deleteDataStory as mutationFn } from 'api/endPoints/deleteDataStory';

export const useMutationDeleteStory = () => {
    return useMutation<unknown, QueryError, number>((id) => mutationFn(id));
};
